<div class="registration-terms-conditions">
  <dgx-components-icon
    [name]="'memo-circle-check'"
    [size]="'md'"
    aria-hidden="true"
    class="xs-self-start mr-3"
  />

  <dgx-components-rich-text
    *ngIf="termsAndConditions"
    [content]="termsAndConditions"
    [dgxTestHook]="testHooks.RichText"
  />
</div>
